<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9354_80802)">
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint0_linear_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint1_radial_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint2_radial_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint3_linear_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint4_linear_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint5_linear_9354_80802)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint6_linear_9354_80802)"
      />
      <path d="M16.403 10.5283C16.0941 10.5438 15.6043 10.697 15.0539 11.3518C14.4319 12.0916 13.328 12.1871 12.5882 11.5651C11.8484 10.9431 11.7529 9.83923 12.3749 9.09945C13.4526 7.81754 14.8051 7.10393 16.228 7.03272C17.6275 6.96267 18.9083 7.52589 19.8215 8.43709C21.7264 10.3377 21.9625 13.5809 19.5197 16.2047C18.8088 16.9682 17.9456 17.8703 17.0744 18.7806C16.7294 19.1411 16.3832 19.5029 16.0446 19.858C15.984 19.9216 16.0291 20.0269 16.117 20.0269H19.983C20.9495 20.0269 21.733 20.8104 21.733 21.7769C21.733 22.7434 20.9495 23.5269 19.983 23.5269H12.9641C11.083 23.5269 9.95791 21.2825 11.3042 19.7985C12.1557 18.8598 13.42 17.5376 14.6256 16.2768C15.4916 15.3712 16.3273 14.4972 16.9581 13.8197C17.6245 13.104 17.7993 12.4765 17.801 12.0359C17.8028 11.5785 17.6214 11.1861 17.3494 10.9147C17.076 10.642 16.7353 10.5117 16.403 10.5283Z"
            fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9354_80802"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BB3FD" />
        <stop offset="1"
              stop-color="#5194EC"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9354_80802"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_9354_80802"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_9354_80802"
                      x1="30"
                      y1="16"
                      x2="25.5"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9354_80802"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.13"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9354_80802"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9354_80802"
                      x1="29.9012"
                      y1="15.7489"
                      x2="2.27791"
                      y2="15.7489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <clipPath id="clip0_9354_80802">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>